import { render, staticRenderFns } from "./fees.vue?vue&type=template&id=2bbb03ea&scoped=true"
import script from "./fees.vue?vue&type=script&lang=js"
export * from "./fees.vue?vue&type=script&lang=js"
import style0 from "./fees.vue?vue&type=style&index=0&id=2bbb03ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb03ea",
  null
  
)

export default component.exports